// extracted by mini-css-extract-plugin
export default {"root":"suYg2","blockList":"cAwpi","icon":"EFj24","iconFallback":"Dqp8e"};